const BackButtonView = () => (
  <button
    className="site-header__back-button bvs-icon is-arrow-left"
    type="button"
    aria-label="Back Button"
    onClick={() => { window.history.back(); }}
  />
);

export default BackButtonView;

// TODO: It would be great to have Icon rendering button elements
